<script lang="ts" context="module">
    export type Emoji = {
        id: string;
        keywords: string[];
        name: string;
        native?: string;
        shortcodes: string;
        unified?: string;
    };
</script>

<script lang="ts">
    import { onMount } from 'svelte';

    export let onSelect: (emoji: Emoji) => void = () => {};

    let root: HTMLDivElement | undefined;

    onMount(async () => {
        const [_mart, i18n] = await Promise.all([
            import('emoji-mart'),
            import('@emoji-mart/data/i18n/fr.json'),
        ]);

        /**
         * Normally we should use mart.Picker directly, but on the legacy version there is a problem,
         * probably because of a conflict with the emoji-mart picker used on the react version.
         *
         * We therefore directly use the Picker defined in the customElements.
         */
        const Picker = customElements.get(
            'em-emoji-picker',
        ) as unknown as typeof _mart.Picker;

        new Picker({
            parent: root,
            onEmojiSelect: (emoji: Emoji) => onSelect(emoji),
            set: 'native',
            locale: 'fr',
            i18n,
            data: async () => {
                const data = await import('@emoji-mart/data');
                return { ...data }; // Make a copy of the data, because Picker will modify it, and like this is import from module, it is read-only
            },
        });
    });
</script>

<div bind:this={root}></div>
